import * as actions from '../actions';

const getInitialState = () => ({
  data: null,
  error: null,
  id: null,
  loaded: false,
  loading: false,
  organizationId: null,
  divisionId: null,
  save: {
    data: null,
    error: null,
    id: null,
    organizationId: null,
    divisionId: null,
    loaded: false,
    loading: false,
  },
});

const groupReducer = (state = getInitialState(), action) => {
  switch (action.type) {
    case actions.GRP_SAVE_FETCH: {
      return {
        ...state,
        save: {
          data: null,
          error: null,
          id: action.payload.groupId,
          loaded: false,
          loading: true,
          organizationId: action.payload.organizationId,
          divisionId: action.payload.divisionId,
        },
      };


    }
    case actions.GRP_SAVE_FETCH_ERROR: {
      return {
        ...state,
        save: {
          data: null,
          error: action.payload,
          loaded: true,
          loading: false,
        },
      };
    }
    case actions.GRP_SAVE_FETCH_SUCCESS: {
      return {
        ...state,
        save: {
          data: action.payload,
          loaded: true,
          loading: false,
        },
      };
    }
    case actions.GRP_DIVISION_USER_DELETE: {
      return {
        ...state,
        data: null,
        error: null,
        id: action.payload.groupId,
        loaded: false,
        loading: true,
        organizationId: action.payload.organizationId,
        divisionId: action.payload.divisionId,
      };
    }
    case actions.GRP_DIVISION_USER_DELETE_ERROR: {
      return {
        ...state,
        data: null,
        error: action.payload,
        loaded: true,
        loading: false,
      };
    }
    case actions.GRP_DIVISION_USER_DELETE_SUCCESS: {
      return {
        ...state,
        data: null,
        loaded: true,
        loading: false,
      };
    }
    default:
      return state;
  }
};


export default groupReducer;